import { LoadingSpinner } from "@fielmann-ag/prisma-components";

import { DEFAULT_LOCALE, getMessages } from "@/i18n";

interface PageLoadingFallbackProps {
  /** Localized status announced while navigating between rendered screens. */
  ariaLabel?: string;
}

/**
 * Preserves the page background and provides loading feedback while a lazily
 * loaded screen is resolving.
 *
 * Default aria-label uses {@link DEFAULT_LOCALE}: the App Suspense fallback
 * mounts before {@link I18nProvider}. Callers inside i18n (e.g. AuthTabs)
 * should pass a locale-aware label.
 */
export function PageLoadingFallback({
  ariaLabel = getMessages(DEFAULT_LOCALE).shared.loading.ariaLabel,
}: PageLoadingFallbackProps = {}) {
  return (
    <div
      data-theme="light"
      className="flex min-h-screen items-center justify-center bg-background-primary"
      role="status"
      aria-label={ariaLabel}
    >
      <LoadingSpinner aria-hidden />
    </div>
  );
}
